import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { InvoiceService } from '../../services/invoice.service';
import { MdDialogRef } from '@angular/material';
import { TdDialogService } from '@covalent/core';
import { Observable } from 'rxjs/Observable';
import { CustomerAutocompleteComponent } from '../../components/customer-autocomplete/customer-autocomplete.component';
import { Customer } from '../../../agatextscreens/accounting/customer';
import { Branch } from '../../../agatextscreens/accounting/branch';
import { AuthenticationService } from '../../services/authentication.service';
import { CustomerService } from '../../../agatextscreens/accounting/customer/customer.service';
import { Bank } from '../../../agatextscreens/accounting/bank';
import { BankService } from '../../services/bank.service';
import { Payment } from '../../../agatextscreens/accounting/payment';
import { PaymentInvoice } from '../../../agatextscreens/accounting/payment-invoice';

import { AccountingService } from '../../../agatextscreens/accounting/accounting.service';

@Component({
  selector: 'app-new-advance-dialog',
  templateUrl: './new-advance-dialog.component.html',
  styleUrls: ['./new-advance-dialog.component.scss'],
  providers: [InvoiceService, CustomerService, BankService, AccountingService]
})
export class NewAdvanceDialogComponent implements OnInit, OnDestroy {

  subscription: Subscription = new Subscription();

  //customer_id: number;
  branch_id: number;
  invoice_date: string;
  type: string = 'Advance';
  total: number;
  bank_id: number;
  description: string;

  allBranches$: Observable<Branch[]>;
  allBanks$: Observable<Bank[]>;

  constructor(private _invoiceService: InvoiceService,
    private _customerService: CustomerService,
    private _dialogRef: MdDialogRef<NewAdvanceDialogComponent>,
    private _authService: AuthenticationService,
    private _bankService: BankService,
    private _dialog: TdDialogService,
    public _accountingService: AccountingService) { }


  selectedCustomer: Customer;
  cust: any;

  allCustomers: Customer[] = [];
  matchingCustomers: Customer[] = [];

  ngOnInit() {


    this.subscription.add(
      this._customerService
      .getCustomers()
      .subscribe((customers: Customer[]) => {
        this.allCustomers = customers;
        this.matchingCustomers = customers.slice(0, 100);

        //this._loadingService.resolve('loading');
      })
    );


    this.allBranches$ = Observable.of(this._authService.getUserBranches());
    this.allBanks$ = this._bankService.getBanks(true);

    this.invoice_date = new Date().toISOString().substr(0, 10);
  }

  ngOnDestroy() {
    console.log('unsubscribing');

    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  setSelected(customer: Customer) {
    this.selectedCustomer = customer;
  }


  // Filter based on user input
  filter(input: string) {
    console.log('input: ' + input);

      this.matchingCustomers = this.allCustomers.filter(
        (cust: Customer) => {
          let full_name = cust.prefix + ' - ' + cust.name;
          return full_name.toLowerCase().includes(input.toLowerCase());
        }
      ).slice(0,100); // limit the matches to 100
  }

  performAction(_do: boolean) {
    if (_do) {

      

      if (!this.selectedCustomer || !this.branch_id || !this.invoice_date || !this.type || !this.total || !this.bank_id || !this.description) {
        this._dialog.openAlert({ title: 'Warning', message: 'Please fill in all fields' });

      } else {

        console.log('customer ID: ' + this.selectedCustomer.id + ', branch ID: ' + this.branch_id + ', invoice date: ' + this.invoice_date + ', invoice type: ' + this.type + ', Total: ' + this.total + ', Bank ID: ' + this.bank_id + ', Description: ' + this.description);

        this.subscription.add(

          // Create the invoice
          //this._invoiceService.createInvoice(Number.parseInt(this.selectedCustomer.id), this.branch_id, 
          this._invoiceService.createInvoice(Number.parseInt(this.selectedCustomer.id), this.branch_id, this.invoice_date, this.type, -this.total).subscribe(
            response => {
              if (response && response['status'] == 'SUCCESS') {
                let invoiceId = response['id'];

                console.log('Successfully created advance invoice: ' + invoiceId);

                // Now deposit the advance into the selected bank

                this.subscription.add(
                  this._bankService.deposit(
                    this.bank_id, 
                    'Advance payment (' + this.selectedCustomer.name + ') ' + this.description, 
                    this.total, 
                    this.invoice_date).subscribe(
                    response => {
                      if (response && response['status'] == 'SUCCESS') {
                        console.log('Advance deposit successfully saved');

/*                        
Apparently we shouldn't mark it cleared, it should be
used like a credit
                        // Now mark the advance invoice as cleared
                        this._invoiceService.updateInvoice(invoiceId, -this.total, 0).subscribe(
                          response => {
                            if (response && response['status'] == 'SUCCESS') {

                              console.log('Invoice cleared: ' + invoiceId);
*/

                              //we need to make a payment entry
                              let payment: Payment = new Payment(
                                {
                                  effective_date: this.invoice_date,
                                  type: 'Advance',
                                  customer_id: Number.parseInt(this.selectedCustomer.id),
                                  customer_name: this.selectedCustomer.name,
                                  amount: this.total,
                                  notes: 'Advance payment ' + this.description
                                }
                              );

                              //console.log(payment);

                              // add a payment for the advance and store it's ID
                              this._accountingService.createPayment(payment).subscribe(
                                response => {
                                  if (response && response['status'] == 'SUCCESS') {

                                    // create payment invoice
                                    let paymentId = response['id'];

                                    console.log('Payment entry created: ' + paymentId);

                                    let paymentInvoice = new PaymentInvoice(
                                      {
                                        invoice_id: invoiceId,
                                        payment_id: paymentId,
                                        amount: this.total,
                                        type: 'Advance',
                                        effective_date: this.invoice_date
                                      });

                                    this._accountingService.createPaymentInvoice([paymentInvoice]).subscribe(
                                      response => {

                                        if (response && response[0] && response[0]['status'] == 'SUCCESS') {

                                          // All done
                                          let _paymentInvoiceId = response[0]['id'];
                                          console.log('Payment Invoice entry: ' + _paymentInvoiceId + ' created for Payment ID: ' + paymentId + ' and invoice ID: ' + invoiceId);

                                          this._dialog.openAlert({ title: 'Success', message: 'Advance invoice created, deposit and payment successfully saved' }).afterClosed().subscribe(
                                            () => {
                                              this._dialogRef.close(true);
                                            });


                                        } else {
                                          this.error('Failed to create payment invoice');
                                        }
                                      },
                                      error => {
                                        this.error('Failed to create payment invoice', error);
                                      });
                                  } else {
                                    this.error('Failed to create payment');
                                  }
                                },
                                error => {
                                  this.error('Failed to create payment', error);
                                });
/*
                            } else {
                              this.error('Error clearing advance invoice');
                            }
                          },
                          error => {
                            this.error('Error clearing advance invoice', error);
                          });
*/                          
                      } else {
                        this.error('Error when creating advance deposit');
                      }
                    },
                    error => {
                      this.error('Error when creating advance deposit', error);
                    })
                );
              } else {
                this.error('Failed to create advance invoice');
              }

            },
            error => {
              this.error('Failed to create advance invoice', error);
            }
          )
        );
      }

    } else {
      this._dialogRef.close(false);
    }
  }

  // error message and close
  error(message: string, error?: any) {

    let errormsg = message;

    if (error) {
      errormsg += ': ' + error;
    }

    console.log(errormsg);
    this._dialog.openAlert({ title: 'Error', message: errormsg }).afterClosed().subscribe(
      () => {
        this._dialogRef.close(false);
      }
    );
  }

}







// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/shared/dialogs/new-advance-dialog/new-advance-dialog.component.ts